import React from 'react';
import { GlobalProvider } from '../../providers';
import PatientGuardComponentContents from
  './patient-guard-component-contents/PatientGuardComponentContents';

const PatientGuardComponent = () => (
  <GlobalProvider>
    <PatientGuardComponentContents />
  </GlobalProvider>
);

export default PatientGuardComponent;
